import { useState, useEffect, useCallback } from 'react';
import useAxios from './useAxios';
//eslint-disable-next-line no-unused-vars
import useCompanyTier from './useCompanyTier';
import { useDownloadOptions } from './useDownloadOptions';
import Constants from '../Constants';

const useCostProjectionDownload = ({ caseId, clientId }) => {
    // for July deployment this is not payment gated 
    // const { isSilverTier } = useCompanyTier();
    const isSilverTier = false;
    const { getData } = useAxios();
    const { downloadCostProjection } = useDownloadOptions();
    const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [alreadyPurchased, setAlreadyPurchased] = useState(false);

    const canDownload = Boolean(caseId && clientId);

    const loadPurchaseStatus = useCallback(async () => {
        if (!isSilverTier || !caseId) return;
        try {
            const { success, data } = await getData(`${Constants.ApiUrl.costProjection.status}/${caseId}`);
            if (success) setAlreadyPurchased(Boolean(data?.purchased));
        } catch {
            console.error('Failed to load cost projection purchase status');
        }
    }, [isSilverTier, caseId, getData]);

    useEffect(() => {
        loadPurchaseStatus();
    }, [loadPurchaseStatus]);

    const closeModal = () => {
        setPurchaseModalOpen(false);
    };

    const performDownload = async () => {
        setIsDownloading(true);
        try {
            await downloadCostProjection({ caseId, clientId });
            setAlreadyPurchased(true);
        } finally {
            setIsDownloading(false);
            closeModal();
        }
    };

    const handleDownloadClick = () => {
        if (!canDownload) return;
        if (!isSilverTier || alreadyPurchased) {
            performDownload();
            return;
        }
        setPurchaseModalOpen(true);
    };

    return {
        canDownload,
        isDownloading,
        purchaseModalOpen,
        handleDownloadClick,
        confirmDownload: performDownload,
        closeModal,
    };
};

export default useCostProjectionDownload;
